import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PanelComponent {
  collapsed = true;
  loaded = false;

  toggle(): void {
    this.collapsed = !this.collapsed;
    this.loaded = true;
  }
}
